import React from 'react'
import { Row } from 'react-bootstrap'
import { connect } from 'react-redux'
import { makeStyles } from '@material-ui/core'
import { COLORES, obtenerColorStock } from '../../../../config/colores'
import DirectionsBoatIcon from '@material-ui/icons/DirectionsBoat'
import LocalShippingIcon from '@material-ui/icons/LocalShipping'
import EstimacionEspacioDisponible from './EstimacionEspacioDisponible'

const useStyles = makeStyles(() => ({
  container: {
    borderRadius: '8px',
    border: '2px solid',
    bordercolor: 'white',
    padding: '8px',
    margin: '8px',
    display: 'flex',
    width: '22%',
    flexDirection: 'column',
    backgroundColor: COLORES.grey.dark,
    color: 'white'
  },
  value: {
    fontWeight: 'bold',
    color: 'white',
    margin: '8px 0 0 0',
    fontSize: '2rem',
    height: '100%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center'
  }
}))

function DetalleFechaProyeccion (props) {
  const { fecha, detalle } = props
  const classes = useStyles()

  const renderDetalle = () => {
    if (detalle) {
      return (
        <Row style={{ flexWrap: 'nowrap' }}>
          <div className={classes.container} >
            <h6 style={{ margin: 0, padding: 0 }}>Fecha</h6>
            <h1 className={classes.value}> {fecha} </h1>
          </div>

          <div className={classes.container} >
            <h6 style={{ margin: 0, padding: 0 }}>Cupos a descargar</h6>
            <h1 className={classes.value}>
              { detalle.cuposADescargar > 0
                ? <> {detalle.cuposADescargar} <LocalShippingIcon style={{ margin: '0 5px' }} /> </>
                : <> - </>
              }
            </h1>
          </div>

          <div className={classes.container} >
            <h6 style={{ margin: 0, padding: 0 }}>Proyectados</h6>
            <h1 className={classes.value}>
              { detalle.cuposProyectados > 0
                ? <> {detalle.cuposProyectados} <LocalShippingIcon style={{ margin: '0 5px' }} /> </>
                : <> - </>
              }
            </h1>
          </div>
          <div className={classes.container} >
            <h6 style={{ margin: 0, padding: 0 }}>Stock final</h6>
            <h1
              className={classes.value}
              style={{ color: obtenerColorStock(detalle.stockFinal).backgroundColor }}
            >
              {detalle.stockFinal} tn. </h1>
          </div>
          <div className={classes.container} >
            <h6 style={{ margin: 0, padding: 0 }}>Embarque <DirectionsBoatIcon /> </h6>
            <h1 className={classes.value}> {detalle.embarquePotencial} tn. </h1>
          </div>
          <div className={classes.container} >
            <h6 style={{ margin: 0, padding: 0 }}>Espacio disponible</h6>
            <h1 className={classes.value}> <EstimacionEspacioDisponible espacioAcumulado={detalle.espacioAcumulado} /> </h1>
          </div>
        </Row>
      )
    }

    return null
  }

  return (
    <> {renderDetalle() } </>
  )
}

const mapStateToProps = (state) => ({
  detalle: state.stock.detalleFechaProyeccion,
  fecha: state.stock.fechaProyeccionSeleccionada,
  cargasAnunciadas: state.stock.cargasAnunciadas
})

const withRedux = connect(mapStateToProps, null)
export default withRedux(DetalleFechaProyeccion)
